import EzController from 'controllers/ez-base-controller';
import Rails from 'rails-ujs';
import { ezClearFormErrors, ezErrorDisplay } from 'ez-styles/assets/javascripts/ez-styles/utils/errors';
import { ezInitPasswordFields } from 'ez-styles/assets/javascripts/ez-styles/forms/password_field';
import { ezInitAnimatedLabels } from 'ez-styles/assets/javascripts/ez-styles/forms/animated_label';
import { parseErrorMsg, emailValidation } from 'lib/validation-helpers';
import { ezLoadingBtnOn, ezLoadingBtnOff } from 'ez-styles/assets/javascripts/ez-styles/utils/buttons';

export default class FormController extends EzController {
  static targets = [
    'formSubmitBtn',
  ];

  connect() {
    this.formValid = false;

    const animLabelInputs = [
      ...this.element.querySelectorAll('.ez-input.ez-input--animated-label'),
    ];

    if (animLabelInputs.length) {
      ezInitAnimatedLabels(animLabelInputs);
    }

    // If we have password fields, we need to make sure the js from the
    // style guide gets loaded
    if (this.element.querySelectorAll('.ez-input__field--password').length) {
      ezInitPasswordFields();
    }
  }

  submit() {
    if (this.element.getAttribute('data-remote') === 'true') {
      Rails.fire(this.element, 'submit');
    } else {
      this.element.submit();
    }
  }

  validateFields() {
    this.resetFormErrors();

    this.checkFields();
  }

  resetFormErrors() {
    ezClearFormErrors(this.element);
  }

  checkFields() {
    this.formValid = true;

    const formFields = [
      ...this.element.querySelectorAll('[required="required"]'),
    ];

    formFields.forEach((field) => {
      const thisFieldId = field.getAttribute('id');
      let fieldErrorMsg = '';

      if (parseErrorMsg(field, 'field_empty_error')) {
        fieldErrorMsg = parseErrorMsg(field, 'field_empty_error');
      }

      // Check for the special "accept terms" checkbox
      if (thisFieldId === 'user_accept_terms') {
        fieldErrorMsg = parseErrorMsg(field, 'checkbox_error');
      }
      this.displayErrorIfEmpty(thisFieldId, fieldErrorMsg);

      // Trim spaces from text input value
      if (field.getAttribute('type') === 'text') {
        field.value = field.value.trim();
      }

      // Make sure any email addresses entered are valid
      if (field.getAttribute('type') === 'email') {
        this.displayErrorIfEmailInvalid(field);
      }
    });

    // Validate any new password/password confirmation inputs
    // TODO: ES-1571 referencing password and password confirmation fields
    //       should be more generic
    const passwordField = document.getElementById('user_password');
    const passwordConfirmField = document.getElementById(
      'user_password_confirmation',
    );

    if (passwordField && passwordConfirmField) {
      this.checkPasswordFields(passwordField, passwordConfirmField);
    }
  }

  checkPasswordFields(passwordField, passwordConfirmField) {
    // First, check to make sure the password inputs are there and have values
    if (
      (passwordField && passwordField.checkValidity())
      || (passwordConfirmField && passwordConfirmField.checkValidity())
    ) {
      // If the passwords mismatch, then go ahead and show that error, if not check the lengths
      if (!this.displayErrorIfFieldMismatch(passwordField, passwordConfirmField, 'password_mismatch')
          && this.displayErrorIfPasswordTooShort(passwordField)) {
        ezErrorDisplay(passwordField);
        ezErrorDisplay(
          passwordConfirmField,
          parseErrorMsg(passwordConfirmField, 'password_length'),
        );
        this.formValid = false;
      }
    }
  }

  displayFormError(field, errorMessage) {
    if (this.formSubmitBtnTarget.classList.contains('has-spinner')) {
      this.hideSpinner();
    }

    ezErrorDisplay(field, errorMessage);

    this.formValid = false;
  }

  displayErrorIfEmpty(fieldId, fieldErrorMsg = '') {
    const thisField = document.getElementById(fieldId);

    if (thisField !== null && !thisField.checkValidity()) {
      ezErrorDisplay(thisField, fieldErrorMsg);
      this.formValid = false;
    }
  }

  displayErrorIfPasswordTooShort(passwordField) {
    const { length } = passwordField.value;
    return length > 0 && length < 6;
  }

  displayErrorIfFieldMismatch(field, confirmField, mismatchErrorKey) {
    if (field.value !== confirmField.value) {
      ezErrorDisplay(field);
      ezErrorDisplay(confirmField,
        parseErrorMsg(confirmField, mismatchErrorKey));
      this.formValid = false;
      return true;
    }

    return false;
  }

  displayErrorIfEmailInvalid(emailField) {
    if (
      emailField
      && emailField.value
      && !emailValidation(emailField.value)
    ) {
      ezErrorDisplay(emailField, parseErrorMsg(emailField, 'invalid_email'));
      this.formValid = false;
    }
  }

  showSpinner() {
    if (this.hasFormSubmitBtnTarget) {
      ezLoadingBtnOn(this.formSubmitBtnTarget);
    }
  }

  hideSpinner() {
    if (this.hasFormSubmitBtnTarget) {
      ezLoadingBtnOff(this.formSubmitBtnTarget);
    }
  }
}
